module.exports = "::slotted([slot=controls]){margin:32px 16px!important;min-width:160px}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-modalnotification/theme/lui-modalnotification.scss
// module id = 277
// module chunks = 0 1 30